import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'

interface AdministrativeCaseFormProps {
  form: UseFormReturn<any>
  isView?: boolean
}

export function AdministrativeCaseForm({ form, isView }: AdministrativeCaseFormProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="Case Title"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Case Title *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter case title" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Case Number"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Case Number *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter case number" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Adverse Party"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Adverse Party *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter adverse party" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Address Of Adverse Party"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Address of Adverse Party *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter address" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="Nature Of Case"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Nature of Case *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter nature of case" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Office Pending"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Office Pending *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter office pending" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Status"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Status *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter status" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="Action Taken"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Action Taken *</FormLabel>
                <FormControl>
                  <Input {...field} disabled={isView} placeholder="Enter action taken" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>

      {/* Full Width Field */}
      <div className="border-t-2 border-primary/20 pt-6">
        <FormField
          control={form.control}
          name="Please Specify"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Please Specify *</FormLabel>
              <FormControl>
                <Textarea
                  {...field}
                  disabled={isView}
                  placeholder="Please provide additional details..."
                  rows={4}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  )
}
